import React from "react";
import styled from "styled-components";
import { Table } from "components/bootstrap";
import useAttributeComponents from "components/event-definitions/replay-search/hooks/useAttributeComponents";
import EventAttribute from "components/event-definitions/replay-search/EventAttribute";
const StyledTable = styled(Table)`
  margin-bottom: 0;
`;
const EventDefinitionInfoTable = () => {
  const infoAttributes = useAttributeComponents();
  return /* @__PURE__ */ React.createElement(StyledTable, { condensed: true, striped: true }, /* @__PURE__ */ React.createElement("tbody", { "data-testid": "info-container" }, infoAttributes.map(
    ({ title, content, show, inRows }) => show !== false && /* @__PURE__ */ React.createElement(EventAttribute, { key: title, title, inRows }, content)
  )));
};
export default EventDefinitionInfoTable;
